module.exports = __webpack_public_path__ + "static/media/browser.74a6609c.png";